import { Routes } from '@common-packages/routes-definitions';

import { LinkCellRendererFactory } from '../../../shared/columnDefinitions/cellRenderers';
import { defaultColumnDefinition } from '../../../shared/columnDefinitions';

const ReportLinkRenderer = LinkCellRendererFactory({
  getText: ({ value }) => value,
  getPathName: (value, { reportId }) => Routes.customTrgReport.compiledRoute({ reportId }),
});

const columnDefinitions = [
  {
    ...defaultColumnDefinition,
    headerName: 'Report ID',
    field: 'reportId',
    width: 60,
  },
  {
    ...defaultColumnDefinition,
    headerName: 'Name',
    field: 'name',
    width: 400,
    cellRenderer: ReportLinkRenderer,
  },
];

export default columnDefinitions;
